import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initScrollingMedia(section) {
  const trackRight = section.querySelector('.track-right');
  const trackLeft = section.querySelector('.track-left');

  gsap.fromTo(
    trackRight,
    { xPercent: -30 },
    {
      xPercent: 0,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top bottom", // Starts when the top of the section hits the bottom of the viewport
        end: "bottom top", // Ends when the bottom of the section hits the top of the viewport
        scrub: 1, // 1 second lag for smooth scrubbing effect
      },
    },
  );

  gsap.fromTo(
    trackLeft,
    { xPercent: 0 },
    {
      xPercent: -30,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
      },
    },
  );
}

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".layout--scrolling-media");
  if (sections.length) {
    sections.forEach(initScrollingMedia);
  }
});
